module.exports = __webpack_public_path__ + "static/briefcases-36723a9f430c64b9527eb1d7528b9e57.png";